/**
 * Service function for logging messages only in dev mode
 * @param {...any} args - Arguments for console output
 */
export const log = (...args) => {
  // Check if we're in dev mode
  if (import.meta.env.DEV) {
    console.log(...args);
  }
};

/**
 * Service function for logging errors only in dev mode
 * @param {...any} args - Arguments for console output
 */
export const logError = (...args) => {
  if (import.meta.env.DEV) {
    console.error(...args);
  }
};

/**
 * Service function for logging warnings only in dev mode
 * @param {...any} args - Arguments for console output
 */
export const logWarn = (...args) => {
  if (import.meta.env.DEV) {
    console.warn(...args);
  }
};

/**
 * Service function for logging information only in dev mode
 * @param {...any} args - Arguments for console output
 */
export const logInfo = (...args) => {
  if (import.meta.env.DEV) {
    console.info(...args);
  }
};

/**
 * Service function for logging debug only in dev mode
 * @param {...any} args - Arguments for console output
 */
export const logDebug = (...args) => {
  if (import.meta.env.DEV) {
    console.debug(...args);
  }
};
